import { Button, Dialog, DialogContent, DialogTitle, ScrollArea, useAlert } from '@kalos/ui';
import { useState } from 'react';

import { useAuth } from '../../../context/AuthContext';
import { RequisitionForm } from './RequisitionForm';
import { UNRECEIVED_TOOLS_COPY } from './requisitionShared';
import { useSubmitRequisition, useUnreceivedToolsQuery } from './useRequisitionShared';

interface RequisitionFormDialogProps {
  userId: number;
}

export const RequisitionFormDialog = ({ userId }: RequisitionFormDialogProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { submit: handleSubmit, isSubmitting } = useSubmitRequisition({
    userId,
    onCreated: () => setIsDialogOpen(false),
  });
  const { user } = useAuth();
  const isManager = user.permissionGroups.some((group) => group.name === 'Manager');

  const userAssetQuery = useUnreceivedToolsQuery(userId);
  const alert = useAlert();

  const onTriggerClick = () => {
    if (!userAssetQuery.isSuccess) throw new Error('Flow should be impossible');
    if (userAssetQuery.data.doesUserHavePendingReceiveItems && !isManager) {
      alert({
        title: UNRECEIVED_TOOLS_COPY.title,
        body: UNRECEIVED_TOOLS_COPY.body,
        cancelButton: 'OK',
      });
      return;
    }
    setIsDialogOpen(true);
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen} modal={true}>
      <Button
        disabled={!userAssetQuery.isSuccess}
        isLoading={userAssetQuery.isPending}
        onClick={onTriggerClick}
        size="sm"
      >
        New Tool Request
      </Button>
      <DialogContent
        className="h-svh max-w-[100vw] overflow-hidden p-0 md:h-[80svh] md:max-w-screen-sm"
        onPointerDownOutside={(e) => {
          e.preventDefault();
          if (
            e.target instanceof Element &&
            (e.target.closest('.pac-container') || e.target.closest('.pac-item'))
          ) {
            e.preventDefault();
          }
        }}
      >
        <ScrollArea className="h-full px-2 pb-4 md:px-4 [&>div]:block">
          <DialogTitle className="py-2 md:py-6">Request New Tool</DialogTitle>
          <RequisitionForm
            userId={userId}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            ignoreTradeRestriction={isManager}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
